module.exports = __webpack_public_path__ + "static/media/apri-back.8ac3e181.png";